import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";

export const updateJob = async (jobId, payload) => {
  try {
    return await postRequest(urls.UPDATE_JOB + `/${jobId}`, payload);
  } catch (err) {
    return err;
  }
};
